import { env } from '../../lib/env.js';

/**
 * Cross-origin sign-in handoff (marketing → dashboard).
 *
 * kilatcarwash.net and dashboard.kilatcarwash.net are different origins, so we
 * cannot share Firebase Auth session storage. Instead we receive a `signInToken`
 * from tenantBootstrap, encode it in the redirect URL fragment, and the
 * dashboard's bootstrap reads it, calls signInWithCustomToken, and removes it
 * from the URL.
 *
 * Fragment (`#`) is used rather than query string because:
 *   - fragments aren't sent to the server (no leak in server logs)
 *   - history-replaceState can strip them without a navigation
 *
 * Token TTL is ~1 hour (Firebase custom token default).
 */

export function redirectToDashboardWithToken(signInToken: string, path = '/welcome'): void {
  const url = new URL(env.dashboardOrigin);
  url.pathname = path;
  url.hash = `signInToken=${encodeURIComponent(signInToken)}`;
  window.location.assign(url.toString());
}

export function redirectToAgentWithToken(signInToken: string, path = '/welcome'): void {
  const url = new URL(env.agentOrigin);
  url.pathname = path;
  url.hash = `signInToken=${encodeURIComponent(signInToken)}`;
  window.location.assign(url.toString());
}

/**
 * Where a RETURNING operator (already has an account) goes to sign in — the
 * dashboard root, which renders the login screen when signed out. Same origin
 * resolution (`env.dashboardOrigin`) as the post-signup handoff above; this is
 * just a plain link, no token.
 */
export function dashboardLoginUrl(): string {
  return new URL('/', env.dashboardOrigin).toString();
}

/**
 * Where a RETURNING agent (already has an account) goes to sign in — the agent
 * PWA root, which renders its login screen when signed out. Same origin
 * resolution (`env.agentOrigin`) as the post-signup agent handoff above; a plain
 * link, no token. Used by the "Already a Kilat agent? Sign in" affordance on the
 * become-an-agent surface (no combined chooser page — owner amendment).
 */
export function agentLoginUrl(): string {
  return new URL('/', env.agentOrigin).toString();
}
